/**
 * UserTable Component
 * 사용자 목록 테이블
 */
import React from 'react';
import Pagination from '@/shared/components/dataDisplay/Pagination';
import { User } from '../types/user.types';
import { formatPhoneNumber } from '@/shared/utils/formatter';
import { USER_ITEMS_PER_PAGE } from '../../shared/config/system.config';
import {
    TABLE_HEADERS,
    EMPTY_MESSAGE,
    getPrmCodeBadgeClass,
    getUseYnBadgeClass,
    displayValue,
    displaySuppType,
    calculateRowIndex,
} from './userManagement.helpers';

// ======== 타입 ========

interface UserTableProps {
    users: User[];
    currentItems: User[];
    currentPage: number;
    totalPages: number;
    onUserClick: (user: User) => void;
    onPageChange: (page: number) => void;
}

// ======== 컴포넌트 ========

const UserTable: React.FC<UserTableProps> = ({
                                                 users,
                                                 currentItems,
                                                 currentPage,
                                                 totalPages,
                                                 onUserClick,
                                                 onPageChange,
                                             }) => {
    return (
        <>
            {/* 검색 결과 건수 */}
            <div className="result-count">
                <i className="fas fa-list" />
                검색 결과: <strong>{users.length.toLocaleString()}건</strong>
            </div>

            <div className="user-management-table-container">
                <div className="user-management-table-wrapper">
                    <table className="user-management-table">
                        <thead>
                        <tr>
                            {TABLE_HEADERS.map((header) => (
                                <th
                                    key={header.key}
                                    style={header.width ? { width: header.width } : undefined}
                                >
                                    {header.label}
                                </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {users.length === 0 ? (
                            <tr>
                                <td
                                    colSpan={TABLE_HEADERS.length}
                                    style={{ textAlign: 'center', padding: '2rem' }}
                                >
                                    {EMPTY_MESSAGE}
                                </td>
                            </tr>
                        ) : (
                            currentItems.map((user, index) => (
                                <tr
                                    key={user.userId}
                                    onClick={() => onUserClick(user)}
                                >
                                    <td>{calculateRowIndex(currentPage, USER_ITEMS_PER_PAGE, index)}</td>
                                    <td>{user.userId}</td>
                                    <td>{user.userName}</td>
                                    <td>{user.userTypeName}</td>
                                    <td>
                                        <span className={`badge ${getPrmCodeBadgeClass(user.prmCode)}`}>
                                            {user.prmCodeName}
                                        </span>
                                    </td>
                                    <td>{displaySuppType(user.userType, user.suppType)}</td>
                                    <td>{formatPhoneNumber(user.phoneNum)}</td>
                                    <td>{displayValue(user.emailInfo)}</td>
                                    <td>
                                        <span className={`badge ${getUseYnBadgeClass(user.useYn)}`}>
                                            {user.useYnName}
                                        </span>
                                    </td>
                                    <td>{user.insUser}</td>
                                    <td>{user.insDate}</td>
                                    <td>{displayValue(user.updUser)}</td>
                                    <td>{displayValue(user.updDate)}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* 페이지네이션 */}
            {users.length > 0 && (
                <div className="pagination-container">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}
                    />
                </div>
            )}
        </>
    );
};

export default UserTable;
